module.exports={Earlier:"それ以前",New:"新規",NoAnnouncements:"お知らせがありません"};